/**
 * Evento global de presencia (misma pestaña / módulos desacoplados).
 * El backend PHP no puede emitir a `window`; la emisión ocurre en cliente
 * tras PUT exitoso y al recibir `user_presence_changed` / `presence_updated` por WS.
 */

export const PRESENCE_UPDATED_EVENT = 'archat:presence_updated';

/**
 * @param {object} payload
 * @param {number|string} payload.user_id
 * @param {string} [payload.status]
 * @param {string|null} [payload.custom_status]
 * @param {string|null} [payload.custom_emoji]
 * @param {string|null} [payload.preset_key]
 * @param {string|null} [payload.expires_at]
 * @param {'put'|'ws'|'unknown'} [payload.source]
 */
export function dispatchPresenceUpdated(payload) {
  if (typeof window === 'undefined') return;
  const detail = {
    user_id: payload.user_id ?? payload.usuario_id,
    status: payload.status ?? null,
    custom_status: payload.custom_status ?? null,
    custom_emoji: payload.custom_emoji ?? null,
    preset_key: payload.preset_key ?? null,
    expires_at: payload.expires_at ?? null,
    source: payload.source ?? 'unknown',
  };
  if (detail.user_id == null || detail.user_id === '') return;
  window.dispatchEvent(new CustomEvent(PRESENCE_UPDATED_EVENT, { detail }));
}
